import api from "./axiosConfig";

// =====================================================================
// (2026-06-08) Módulo de Compras — API client
// =====================================================================

const _list = async (url, params = {}) => {
  try {
    const r = await api.get(url, { params });
    return r.data;
  } catch (e) {
    if (e?.response?.status === 404) return [];
    throw e;
  }
};

// --- Proveedores ---
export const getProveedores = (params = {}) => _list("/api/suppliers", params);
export const getProveedor = async (id) => (await api.get(`/api/suppliers/${id}`)).data;
export const createProveedor = async (b) => (await api.post("/api/suppliers", b)).data;
export const updateProveedor = async (id, b) => (await api.put(`/api/suppliers/${id}`, b)).data;
export const deleteProveedor = async (id) => (await api.delete(`/api/suppliers/${id}`)).data;

// --- Categorías de gasto ---
export const getCategoriasGasto = (params = {}) => _list("/api/expense-categories", params);
export const createCategoriaGasto = async (b) => (await api.post("/api/expense-categories", b)).data;
export const updateCategoriaGasto = async (id, b) => (await api.put(`/api/expense-categories/${id}`, b)).data;
export const deleteCategoriaGasto = async (id) => (await api.delete(`/api/expense-categories/${id}`)).data;

// --- Gastos ---
export const getGastos = (params = {}) => _list("/api/expenses", params);
export const getGasto = async (id) => (await api.get(`/api/expenses/${id}`)).data;
export const createGasto = async (b) => (await api.post("/api/expenses", b)).data;
export const updateGasto = async (id, b) => (await api.put(`/api/expenses/${id}`, b)).data;
export const addGastoPago = async (id, b) => (await api.post(`/api/expenses/${id}/payments`, b)).data;
export const cancelGasto = async (id, motivo) => (await api.post(`/api/expenses/${id}/cancel`, { motivo })).data;

// --- Compras ---
export const getCompras = (params = {}) => _list("/api/purchases", params);
export const getCompra = async (id) => (await api.get(`/api/purchases/${id}`)).data;
export const createCompra = async (b) => (await api.post("/api/purchases", b)).data;
export const updateCompra = async (id, b) => (await api.put(`/api/purchases/${id}`, b)).data;
export const registerCompra = async (id, b = {}) => (await api.post(`/api/purchases/${id}/register`, b)).data;
export const addCompraPago = async (id, b) => (await api.post(`/api/purchases/${id}/payments`, b)).data;
export const cancelCompra = async (id, motivo) => (await api.post(`/api/purchases/${id}/cancel`, { motivo })).data;
export const getRetentionVouchers = async (id) => (await api.get(`/api/purchases/${id}/retention-vouchers`)).data;
export const checkDuplicateCompra = async (params) => (await api.get("/api/purchases/check-duplicate", { params })).data;

// --- Órdenes de compra ---
export const getOrdenesCompra = (params = {}) => _list("/api/purchase-orders", params);
export const getOrdenCompra = async (id) => (await api.get(`/api/purchase-orders/${id}`)).data;
export const createOrdenCompra = async (b) => (await api.post("/api/purchase-orders", b)).data;
export const updateOrdenCompra = async (id, b) => (await api.put(`/api/purchase-orders/${id}`, b)).data;
export const approveOC = async (id) => (await api.post(`/api/purchase-orders/${id}/approve`)).data;
export const sendOC = async (id) => (await api.post(`/api/purchase-orders/${id}/send`)).data;
export const receiveOC = async (id, b) => (await api.post(`/api/purchase-orders/${id}/receive`, b)).data;
export const cancelOC = async (id) => (await api.post(`/api/purchase-orders/${id}/cancel`)).data;
export const ocToPurchase = async (id, b) => (await api.post(`/api/purchase-orders/${id}/to-purchase`, b)).data;

// --- Catálogos auxiliares (endpoints existentes) ---
export const getIvaCategorias = async () => {
  try { return (await api.get("/api/config/iva-categorias")).data; }
  catch (e) { if (e?.response?.status === 404) return []; throw e; }
};
export const getMetodosPago = async () => {
  try { return (await api.get("/api/config/metodos-pago")).data; }
  catch (e) { if (e?.response?.status === 404) return []; throw e; }
};
export const getProductosCompra = async () => {
  try { return (await api.get("/api/products/")).data; }
  catch (e) { if (e?.response?.status === 404) return []; throw e; }
};

// --- Libro de Compras ---
export const getLibroCompras = async (params = {}) => (await api.get("/api/reports/purchase-ledger", { params })).data;
export const downloadLibroComprasXlsx = async (params = {}) => {
  const r = await api.get("/api/reports/purchase-ledger", {
    params: { ...params, formato: "xlsx" },
    responseType: "blob",
  });
  return r.data;
};
